module.exports = __webpack_public_path__ + "media/images/flower2-615b46a7dc2e3502dd29dffb76f9275d.png";